var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4451",
    "data-name": "Group 4451",
    transform: "translate(-1107.956 -1570)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "correct_24px",
    d: "M34.609,16.385a1.875,1.875,0,0,1,0,2.652L22.031,31.615a1.875,1.875,0,0,1-2.652,0l-5.988-5.988a1.875,1.875,0,1,1,2.651-2.651L20.7,27.638,31.957,16.385a1.875,1.875,0,0,1,2.652,0ZM48,24A24,24,0,1,1,24,0,23.987,23.987,0,0,1,48,24Zm-3.75,0A20.25,20.25,0,1,0,24,44.25,20.239,20.239,0,0,0,44.25,24Zm0,0",
    transform: "translate(1107.956 1570)",
    fill: "#2ca819"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.086222e2a389023b85e784d659cdcf22.svg";
export { ForwardRef as ReactComponent };